import { getLocale, getStoreLocatorURL } from '@pb/utils'
import { path } from 'ramda'

const locale = getLocale()

export const PAYMENT_PROVIDERS = {
  ADYEN: 'ADYEN',
  CYBERSOURCE: 'CYBERSOURCE',
  KLARNA: 'OMNICREDIT',
  PAYPAL: 'PAYPAL',
  P24: 'P24',
  IDEAL: 'IDEAL',
  RUPAY: 'Rupay',
  RAZORPAY: 'RAZORPAY',
  CREDITGUARD: 'CreditGuard',
}

export const API_ENDPOINTS = {
  storeLocator: getStoreLocatorURL(locale),
  DCDUrl: `${process.env.DCD_BASE_URL}/api/user-data`,
}

export const CUSTOMER_TYPES = {
  GUEST: 'GUEST',
  REGISTERED: 'REGISTERED',
  TEMPORARY: 'TEMPORARY',
}

export const USER_CLUB_JOIN_STATUS = {
  INITIAL: 'INITIAL',
  NON_MEMBER: 'NON_MEMBER',
  PENDING: 'PENDING',
  PENDING_ABORTED: 'PENDING_ABORTED',
  SUBSCRIBER: 'SUBSCRIBER',
  FULL_MEMBER: 'FULL_MEMBER',
}

export const ACCOUNT_HOLDER_STATUSES = [
  USER_CLUB_JOIN_STATUS.PENDING,
  USER_CLUB_JOIN_STATUS.INITIAL,
  USER_CLUB_JOIN_STATUS.FULL_MEMBER,
]

export const TECHNICAL_ERROR_LABELS = {
  general: 'checkout.error.general.retry',
  generalNoAction: 'checkout.error.general',
}

export const ERROR_CODES = {
  technicalError: 'TECHNICAL_ERROR',
  anonymous: 'ANONYMOUS_USER',
}

export const IS_PASSWORD_METER_ENABLED =
  path(['options', 'passwordStrengthScript', 'enabled'], window.hm) !== false
